import * as actions from "store/actions";

const initialState = {
    previewState: {},
    serverState: {},
};

const WebchatSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.EXAMPLE_RAN:
            return {
                ...state,
                previewState: action.payload,
            };
        default:
            return state;
    }
};

export default WebchatSettingsReducer;
